export default __webpack_public_path__ + "static/media/bootstrap.f1c789fb.less";